import get from 'lodash.get';

import { createDeepEqualSelector } from '../../redux/utils/selectors';
import {
  PRODUCT_ADVANCED_PRICES,
  PRODUCT_PROFESSIONAL_PRICES,
  BILLING_CYCLE_YEARLY,
  PRODUCT_ADVANCED_YEARLY,
  PRODUCT_ADVANCED_MONTHLY,
  PRODUCT_PROFESSIONAL_YEARLY,
  PRODUCT_PROFESSIONAL_MONTHLY,
} from '../../constants/payment';

const selectBillingCycle = (_, props) => props.billingCycle;

export const selectPlanAdvanced = createDeepEqualSelector([selectBillingCycle], (billingCycle) =>
  billingCycle === BILLING_CYCLE_YEARLY ? PRODUCT_ADVANCED_YEARLY : PRODUCT_ADVANCED_MONTHLY,
);

export const selectPlanProfessional = createDeepEqualSelector([selectBillingCycle], (billingCycle) =>
  billingCycle === BILLING_CYCLE_YEARLY ? PRODUCT_PROFESSIONAL_YEARLY : PRODUCT_PROFESSIONAL_MONTHLY,
);

export const selectPriceAdvanced = createDeepEqualSelector([selectBillingCycle], (billingCycle) => {
  const price = get(PRODUCT_ADVANCED_PRICES, billingCycle, 0);

  return `$${price}`;
});

export const selectPriceProfessional = createDeepEqualSelector([selectBillingCycle], (billingCycle) => {
  const price = get(PRODUCT_PROFESSIONAL_PRICES, billingCycle, 0);

  return `$${price}`;
});
